import React from 'react';
import {Container, Text} from '@inlet/react-pixi';
import {RichTextTextStyle} from '@gongxigames/framework/core';
import {Rectangle} from '@gongxigames/framework/core/fragments/react';

type LoadingLayerProps = {
    width: number;
    height: number;
    style: Partial<RichTextTextStyle>;
};

export function LoadingLayer({height, width, style}: LoadingLayerProps): JSX.Element {
    return (
        <Container>
            <Rectangle width={width} height={height} fill={0x000000} alpha={0.5} />
            <Text style={style} text={'LOADING...'} x={width / 2} y={height / 2} anchor={0.5}/>
        </Container>
    );
}
